import React from 'react';
import { logout } from '../auth';

export default function Header({ user }) {
  const displayName = user?.name || user?.email || 'Staff member';
  return (
    <header className="app-header">
      <div className="brand">
        <span className="logo-text">NurturingNurses&reg; HomeCare</span>
        <span className="divider" />
        <span className="title">My Training</span>
      </div>
      <div className="user">
        <span className="name">{displayName}</span>
        <button type="button" className="btn-ghost" onClick={logout}>
          Log out
        </button>
      </div>
    </header>
  );
}
